/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    getClientContacts: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.client_id + '/contacts', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createClientContact: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/contacts', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteClientContact: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('clients/' + data.cliente_id + '/contacts/' + data.contact_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClientContact: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('clients/' + data.cliente_id + '/contacts/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClientContactPermissions: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/contacts/' + data.id + '/permissions', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClientContactNotifications: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/contacts/' + data.id + '/notifications', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ClientContactsModule.js